<template>
  <card>
    <div slot="title">
      <div class="flex" style="justify-content: space-between">
        <h4>入住率排名</h4>
        <select-range  @search="search" ref="date" :disabledDate=false></select-range>
      </div>
    </div>
      <ul style="margin-top: 16px">
        <li v-for="(item,index) in projectInfos" :key="'keyB'+index">
          <span>
            <span :class="[0,1,2].indexOf(index)===-1?'indexothers':'index012'"> {{index+1}}</span>
            <span>{{item.name}}</span>
          </span>
          <span>{{(item.value*100).toFixed(2)+'%'}}</span>
        </li>
      </ul>
  </card>
</template>

<script>
import Card from './Card'
import SelectRange from './SelectRange'
import { sortCheckinRate } from 'api/reporter'
export default {
  name:'CheckInSort',
  components:{
    SelectRange,
    Card
  },
  props:{
    projectFid:{
      type:String,
      default:''
    },
    projectFidList:{
      type:Array,
      default(){
        return []
      }
    },

  },
  data(){
    return{
      projectInfos: []
    }
  },
  watch:{
    projectFidList:{
      deep:true,
      handler(newVal,oldVal){
        console.log(newVal,oldVal)
        this.$refs['date'] && this.search(this.$refs['date'].searchParams)
      }
    }
  },
  methods:{
    search(data){
      console.log(data,'ref')
      const params={
        projectFidList:this.projectFidList,
        ...data,
      }
      sortCheckinRate(params).then(res => {
        if(!res.data){
          return
        }
        this.projectInfos = res.data.projectInfos
      }).catch(() => {return})
    },
  }

}
</script>

<style scoped>
  .rank {
    height: 100%;
    overflow: auto;
    /* width: 300px; */
    /*background-color: lightsalmon;*/
    padding: 0 30px;
  }

  .index012, .indexothers {
    display: inline-block;
    margin-right: 15px;

    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 9px;

  }

  .index012 {
    background-color: #444444;
    color: white;

  }

  .indexothers {
    background-color: #F9F9F9;
    color: black;

  }
</style>